import http from "./http";
export default <{ [key: string]: any }>{
	getMenu(method: string = "") {
		return http.get("Pub/getMenu" + (method ? `/${method}` : ""));
	},
	getStroke(uid: string) {
		return http.get(`Schedule/getStroke/${uid}`);
	},

	saveDay(data: any) {
		return http.post(`Schedule/saveDay`, data);
	},

	getField(folder: any, page = 0, pagenumber = 20) {
		return http.post(`Pub/getField/${page}/${pagenumber}`, {
			folder: folder.folder,
			imagetype: folder.imagetype ?? ["image", "iframe"]
		});
	},

	saveFolder(data: any) {
		return http.post("Pub/saveFolder", data);
	},

	moveField(data: any) {
		return http.post("Pub/moveField", data);
		// return PubApi.moveField(data);
	},

	insertSystemImage(data: any) {
		return http.post("Pub/insertSystemImage", data);
		// return PubApi.insertSystemImage(data);
	},

	getLogData(agency: string) {
		return http.get(`otherApi/getLogData/${agency}`);
	},
	getNoticeMessage(page: number, pagenumber: number, where: any = {}) {
		return http.get(`getNoticeMessage/${page}/${pagenumber}`, { search: where });
	},
	readNoticeMessage(uid: string = "") {
		return http.post(`readNoticeMessage/${uid}`);
	},
	auto(agency: string, field: any) {
		return http.post(`otherApi/auto/${agency}`, { include: field });
	},

	autoOutData(agency: string) {
		return http.get("otherApi/autoOutData/" + agency);
	},

	autoStroke(agency: string) {
		return http.get("otherApi/autoStroke/" + agency);
	},

	setTransferClass(agency: string, data: any) {
		return http.post("otherApi/setTransferClass/" + agency, data);
	},
	getTransferClass(agency: string) {
		return http.get("otherApi/getTransferClass/" + agency);
	},

	getOutData(agency: string, search: any) {
		return http.get("otherApi/getOutData/" + agency, search);
	},

	importOutData(agency: string, data: any) {
		return http.post("otherApi/importOutData/" + agency, data);
	},

	updateOutData(agency: string, data: any) {
		return http.post("otherApi/updateOutData/" + agency, data);
	},
	importTourOutData(agency: string, data: any) {
		return http.post("otherApi/importTourOutData/" + agency, data);
	},
	updateTourOutData(agency: string, data: any) {
		return http.post("otherApi/updateTourOutData/" + agency, data);
	},
	getPubClass(func: string, where = {}) {
		return http.post("datainfo/getPubClass/" + func, where);
	},
	getPaySource(where: any) {
		return http.post("datainfo/getPaySource", where);
	},
	getCountry(where = {}) {
		return http.post("datainfo/getCountry", where);
	},
	getCity(country: string, where = {}) {
		return http.post("datainfo/getCity/" + country, where);
	},
	getPostCode(city: string, where = {}) {
		return http.post("datainfo/getPostCode/" + city, where);
	},
	getServiceArea(country: string, where = {}) {
		return http.get("datainfo/getServiceArea/" + country, where);
	},
	SendforgotPwd(taxId: string, email: string) {
		return http.get(`forgotpwd/company/${taxId}/${email}`);
	},
	CheckShortUrl(code: string) {
		return http.get(`CheckShortUrl/${code}`);
	},
	forgotchangePwd(pwd: string, code: string) {
		return http.post(`forgotchangePwd/${code}`, {
			pwd: pwd,
		});
	},
	getData(table: string, search: any | null) {
		return http.post("Pub/getdata/" + table, search);
	},

	getMulitData(tablelist: Array<any>, cancelfunc = null) {
		return http.post(
			"Pub/getMulitData",
			{
				data: tablelist,
			},
			null,
			cancelfunc
		);
	},
	autoSave(maintable: string, main: any, sub: Array<{
		mainfield: string,
		subfield: string,
		subtable: string,
		subdata: Array<any>
	}>, cancelfunc = null) {
		return http.post(
			"Pub/autoSave",
			{
				maintable: maintable,
				maindata: main,
				subdata: sub
			},
			null,
			cancelfunc
		);
	},

	getAirPort(where: any = null, page: any = 0, pagenumber: any = "all") {
		return http.get(`datainfo/getAirPort/${page}/${pagenumber}`, where);
	},

	getAirLine(where: any = null, page: any = 0, pagenumber: any = "all") {
		return http.get(`datainfo/getAirLine/${page}/${pagenumber}`, where);
	},
	// =========
	checkApi() {
		return http.get("Public/ChApi");
	},
	pbRequest(table: string) {
		return http.get("pbRequest", { table: table });
	},
	pbMultiRequest(table: Array<string>) {
		return http.get("pbMultiRequest", { table: table.join(",") });
	},
	UpdateUserInfo(table: string, Info: any) {
		console.log(Info);
		return http.post("UpdateUserInfo", { table: table, updateinfo: Info });
	},
	UpdateCompanyInfo(table: string, Info: any) {
		return http.post("UpdateCompanyInfo", { table: table, updateinfo: Info });
	},

	getUseCountry() {
		return http.get("getUseCountry");
	},
	getGoLocation(where: any = null) {
		return http.post("getGoLocation", where);
	},

	getSkillPosition(where: any) {
		return http.post("getSkillPosition", { where: where });
	},
	getCaseCode(where: any) {
		return http.post("getCaseCode", { where: where });
	},
	getLanguageCode(where: any) {
		return http.post("getLanguageCode", { where: where });
	},
	getTagsCode() {
		return http.get("getTagsCode");
	},
	getLicenceCategory(where: any) {
		return http.post("getLicenceCategory", { where: where });
	},
	getLicenceCode(where: any) {
		return http.post("getLicenceCode", { where: where });
	},
	getCurrency(where: any) {
		return http.post("datainfo/getCurrency", { where: where });
	},
	getStarSign() {
		return http.get("getStarSign");
	},
	getBankCode() {
		return http.get("getBankCode");
	},

	getWebImage(website: string) {
		return http.post("Pub/getWebImage", {
			website: website,
		});
	},

	getPointImage(data: Object) {
		return http.get("Schedule/getPointImage", data);
	},

	// manage

	getElement(search: any, page: number, pagenumber: number | "all") {
		return http.get(`Manage/getElement/${page}/${pagenumber}`, search);
	},

	editSpecial(data: Object) {
		return http.post(`Manage/editSpecial`, data);
	},

	editSpecialItem(data: Object) {
		return http.post(`Manage/editSpecialItem`, data);
	},

	editSpecialPackage(data: Object) {
		return http.post(`Manage/editSpecialPackage`, data);
	},
	deleteSpecialItem(data: string) {
		return http.delete(`Manage/deleteSpecialItem`, [
			{
				uid: data,
				delete: true,
			},
		]);
	},
	deleteSpecial(data: Object) {
		return http.delete(`Manage/deleteSpecial`, {
			uid: data,
			delete: true,
		});
	},
	deleteSpecialPackage(data: string) {
		return http.delete(`Manage/deleteSpecialPackage`, {
			uid: data,
			delete: 1,
		});
	},

	editRemarkItem(data: Object) {
		return http.post(`Manage/editRemarkItem`, data);
	},
	deleteRemarkItem(data: string) {
		return http.delete(`Manage/deleteRemarkItem`, [
			{
				uid: data,
				delete: 1,
			},
		]);
	},

	editRemarkPackage(data: Object) {
		return http.post(`Manage/editRemarkPackage`, data);
	},
	deleteRemarkPackage(data: string) {
		return http.delete(`Manage/deleteRemarkPackage`, {
			uid: data,
			delete: 1,
		});
	},

	editRemark(data: Object) {
		return http.post(`Manage/editRemark`, data);
	},
	deleteRemark(data: string) {
		return http.delete(`Manage/deleteRemark`, {
			uid: data,
			delete: 1,
		});
	},

	getFlightBoard(search: any, page: number, pagenumber: number | "all") {
		return http.get(`datainfo/getFlightBoard/${page}/${pagenumber}`, search);
	},

	getSpecial(search: any, page: number, pagenumber: number | "all", method: string | "tempSpecial") {
		return http.get(`Manage/getSpecial/${method}/${page}/${pagenumber}`, search);
	},

	getSpecialPackage(search: any, page: number, pagenumber: number | "all") {
		return http.get(`Manage/getSpecialPackage/${page}/${pagenumber}`, search);
	},

	getSpecialPackageItem(uid: string) {
		return http.get(`Manage/getSpecialPackageItem/${uid}`);
	},

	getRemark(search: any, page: number, pagenumber: number | "all", method: string | "tempRemark") {
		return http.get(`Manage/getRemark/${method}/${page}/${pagenumber}`, search);
	},

	getRemarkPackage(search: any, page: number, pagenumber: number | "all") {
		return http.get(`Manage/getRemarkPackage/${page}/${pagenumber}`, search);
	},

	getRemarkPackageItem(uid: string) {
		return http.get(`Manage/getRemarkPackageItem/${uid}`);
	},
	sendMessage(formdata: any) {
		return http.post("Pub/sendMessage", formdata);
	},
	SetSendManage(method: string, formdata: any) {
		return http.post(`Pub/SetSendManage/${method}`, formdata);
	},
	getSendManage(method: string) {
		return http.get(`Pub/getSendManage/${method}`);
	},
	getMsgPoint() {
		return http.get(`Pub/getMsgPoint`);
	},
	getPassportConverterChin(firstname: string, lastname: string) {
		return http.get("Pub/PassportConverterChin", { firstname: firstname, lastname: lastname });
	},
	getLocationToEng(location: string) {
		return http.get("Pub/getLocationToEng", { location: location });
	},
	getAgencySource() {
		return http.get(`otherApi/getAgencySource`);
	},
	getCompanyInfo() {
		return http.get(`getCompanyInfo`);
	},
	getAdjustList(method: string, belong_uid: string, page: number = 0, pagenumber: number = 20) {
		return http.get(`Pub/getAdjustList/${method}/${belong_uid}/${page}/${pagenumber}`);
	},
	getAdjustInfo(uid: string,) {
		return http.get(`Pub/getAdjustInfo/${uid}`);
	},
	EditAdjust(belonguid: string, formdata: any) {
		belonguid = belonguid ? belonguid : "add"
		return http.post(`Pub/EditAdjust/${belonguid}`, formdata);
	},
	createEDCard(data: any) {
		return http.post(`Print/createEDCard`, data);
	},

	getEDCardSetting() {
		return http.get(`Print/getEDCardSetting`);
	},

	deleteEDCardField(uid: string) {
		return http.delete(`Print/deleteEDCardField/${uid}`);
	},

	editPnrSetting(data: any) {
		return http.post(`Print/editPnrSetting`, data);
	},
	getPnrSetting() {
		return http.get(`Print/getPnrSetting`);
	},
	editPnrStroke(data: any) {
		return http.post(`Print/editPnrStroke`, data);
	},
	setPnrCode(data: any) {
		return http.post(`Print/setPnrCode`, data);
	},
	editCustomForm(data: any) {
		return http.post("editCustomForm", data);
	},
	deleteCustomForm(uid: string) {
		return http.delete(`deleteCustomForm/${uid}`);
	},
	readReadNotice(uid: string) {
		return http.post(`readReadNotice/${uid}`)
	},
	doingPid(method: string, pid: any) {
		return http.get(`otherApi/doingPid/${method}/${pid}`);
	},
	GoogleOcr(image: string, sourceUid: string) {
		return http.post(`GoogleOcr`, { image: image, sourceUid: sourceUid });
	},
	getSysHistory(method: string, page: number = 0, pagenumber: number | string = 20, search: any = {}) {
		return http.get(`Pub/getSysHistory/${method}/${page}/${pagenumber}`, { search: JSON.stringify(search) });
	},
	EditAdjustAcoount(data: any) {
		return http.post("Pub/EditAdjustAcoount", data);
	},

	AdjustAcoountList(searchData: string, page = 0, pagenumber = 20, orderBy: OrderBy = { name: "createtime", order: "desc" }) {
		return http.get(`Pub/AdjustAcoountList/${page}/${pagenumber}`, { search: searchData, orderBy: JSON.stringify(orderBy) });
	}
};
